import React, {Component} from 'react';
import '../../framework/SpreadTable/spread-table.css';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import ArrowRight from 'material-ui/svg-icons/av/play-arrow';
import moment from 'moment';
/**
 * @author chargoyao
 * @property tableHeaderArr {array} table header array.
 * [{label: 'ClientName', value: 'ClientName'}]
 * @property renderCols {obj} render data column
 * {
 *  addedCol: 'xxx',
 *  cols: ['xxx', 'xxxx']
 * }
 *
 * @property bodyDataArr {array} remote data
 * [{
 *  clientName: 'Deluth Trading',
 *  bizUnitName: 'Monsanto',
 *  deploymentType: 'WebProperty',
 *  domain: 'www.abc.com',
 *  uuid: 291923-11,
 *  activeStatus: Inactive
 *  }, {
 *    clientName: 'Deluth Trading',
 *    bizUnitName: 'Monsanto',
 *    deploymentType: 'WebProperty',
 *    domain: 'www.abc.com',
 *    uuid: 291923-11,
 *    activeStatus: Inactive
 *    children: [
 *    ]
 *  }]
 *  @property tableHeaderWidthStyle {array} table Width style
 *  ['22%', '12%']
 */
const arrowStyles = {
  position: 'absolute',
  right: 0,
  top: '7px'
}
class UsersTable extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeIndex: 0,
      arrowActive: 'down',
      expandAll: false
    }
  }

  componentDidMount () {
    if (this.props.expandAll === true) {
      this.setState({expandAll: true})
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.expandAll !== this.props.expandAll) {
      this.setState({expandAll: nextProps.expandAll === true})
    }
  }
  handleClick (label, index) {
    this.setState({
      activeIndex: index
    });
    if (+index === this.state.activeIndex) {
      if (this.state.arrowActive === 'down') {
        this.setState({
          arrowActive: 'up'
        })
      } else {
        this.setState({
          arrowActive: 'down'
        })
      }
    } else {
      this.setState({
        arrowActive: 'down'
      })
    }
    if (index === 0) {
      this.props.handleSortByClientName()
    }
  }
  spreadTr (index) {
    if (this.state[`spread${index}`]) {
      this.setState({
        [`spread${index}`]: false,
        expandAll: false
      })
    } else {
      this.setState({
        [`spread${index}`]: true,
        expandAll: false
      });
    }
  }
  render () {
    return (
      <div className="spread-table">
        <table>
          <tbody>
          <tr>
            {this.props.tableHeaderArr.map((item, index) => {
              let widthStyle = '';
              switch (index) {
                case 0:
                  widthStyle = this.props.tableHeaderWidthStyle[0];
                  break;
                case 1:
                  widthStyle = this.props.tableHeaderWidthStyle[1];
                  break;
                case 2:
                  widthStyle = this.props.tableHeaderWidthStyle[2];
                  break;
                case 3:
                  widthStyle = this.props.tableHeaderWidthStyle[3];
                  break;
                case 4:
                  widthStyle = this.props.tableHeaderWidthStyle[4];
                  break;
                case 5:
                  widthStyle = this.props.tableHeaderWidthStyle[5];
                  break;
                case 6:
                  widthStyle = this.props.tableHeaderWidthStyle[6];
                  break;
                default:
                  widthStyle = '';
                  break;
              }
              return (
                <th key={item.value}
                    className={this.state.activeIndex === index && index === 0 ? 'active' : ''}
                    onClick={() => {if (item.label === 'Client Name') this.handleClick(item.label, index)}}
                    style={{width: widthStyle, whiteSpace: 'pre-wrap'}}
                >
                  {item.label}
                  {
                    (
                      this.state.activeIndex === index &&
                      this.state.arrowActive === 'down' &&
                      index === 0
                    ) && (
                      <ArrowDown
                        style={{
                          ...arrowStyles
                        }}
                      />
                    )
                  }
                  {
                    (
                      this.state.activeIndex === index &&
                      this.state.arrowActive === 'up' &&
                      index === 0
                    ) && (
                      <ArrowUp
                        style={{
                          ...arrowStyles
                        }}
                      />
                    )
                  }
                </th>
              )
            })}
          </tr>
          {
            this.props.bodyDataArr.map((item, index) => {
              if (item.children.length === 0) {
                return (
                  <tr key={index}>
                    <td style={{paddingLeft: 0}}>
                      {item.clientName}
                    </td>
                    <td>
                      {item.bizUnitName}
                    </td>
                    <td>
                      {item.user && item.user.username}
                    </td>
                    <td>
                      {item.user && item.user.role.name}
                    </td>
                    <td>
                      {item.user && item.user.email}
                    </td>
                    <td>
                      {item.user && item.user.status}
                    </td>
                    <td>
                      {(item.user && item.user.lastLoggedonDatetime) && moment(item.user.lastLoggedonDatetime).format('M/DD/YY')}
                    </td>
                  </tr>
                )
              } else {
                let obj  = [];
                if (item.children.length >= 1){
                  obj.push(
                    <tr key={index} onClick={() => this.spreadTr(index)}>
                      <td style={{paddingLeft: '20px', cursor: 'pointer'}}>
                        {
                          (this.state[`spread${index}`] || this.state.expandAll) ? (
                            <ArrowDown
                              style={{position: 'absolute', left: '-7px', top: '2px'}}
                            />
                          ) : (
                            <ArrowRight
                              style={{position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px'}}
                            />
                          )
                        }{item.clientName}
                      </td>
                      <td style={{cursor: 'pointer'}}>
                        {item.bizUnitName}
                      </td>
                      <td style={{cursor: 'pointer'}}>
                        {item.user && item.user.username}
                      </td>
                      <td style={{cursor: 'pointer'}}>
                        {item.user && item.user.role.name}
                      </td>
                      <td style={{cursor: 'pointer'}}>
                        {item.user && item.user.email}
                      </td>
                      <td>
                        {item.user && item.user.status}
                      </td>
                      <td>
                        {item.user ? moment(item.user.lastLoggedonDatetime).format('M/DD/YY') : ''}
                      </td>
                    </tr>
                  );
                }
                for(let v of item.children) {
                  obj.push(
                    <tr style={{display: this.state[`spread${index}`] || this.state.expandAll ? 'table-row' : 'none'}}>
                      <td style={{paddingLeft: '49px'}}>
                        {v.clientName}
                      </td>
                      <td>
                        {v.bizUnitName}
                      </td>
                      <td>
                        {v.user && v.user.username}
                      </td>
                      <td>
                        {v.user && v.user.role.name}
                      </td>
                      <td>
                        {v.user && v.user.email}
                      </td>
                      <td>
                        {v.user && v.user.status}
                      </td>
                      <td>
                        {v.user ? moment(v.user.lastLoggedonDatetime).format('M/DD/YY') : ''}
                      </td>
                    </tr>
                  )
                }

                return obj;
              }
            })}
          </tbody>

        </table>
      </div>
    )
  }
}

UsersTable.defaultProps = {
  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
  bodyDataArr: [],
  renderCols: {
    addCol: '',
    cols: []
  }
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/ClientBusinessInfoAndUser/Users/UsersTable.jsx